import { Expose } from "class-transformer";
import { IsBoolean, IsOptional, IsString } from "class-validator";

export class ContractorViewModel {
  @IsOptional()
  @IsString()
  @Expose()
  name!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  surname!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  country!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  city!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  postalCode!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  streetAndNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  tin!: string | null;
  @IsBoolean()
  @Expose()
  isIndividual!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  nationalBusinessRegistryNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  importedContractorId!: string | null;
}
